import { default as uuidV4 } from 'uuid/v4';
import GeoPoint from 'Faster/model/GeoPoint';

class Session {
  public readonly id: string;
  public readonly userId?: string;
  public readonly geoPoint?: GeoPoint;
  public readonly properties?: object;
  public readonly createdInBackground: boolean;
  public readonly startedAt: Date;
  public readonly ntpStartedAt?: Date;
  public readonly updatedAt?: Date;
  public readonly ntpUpdatedAt?: Date;
  public readonly closed: boolean;
  public readonly remotelyPersisted: boolean;

  public constructor(
    id?: string,
    userId?: string,
    geoPoint?: GeoPoint,
    properties?: object,
    createdInBackground = false,
    startedAt?: Date,
    ntpStartedAt?: Date,
    updatedAt?: Date,
    ntpUpdatedAt?: Date,
    closed = false,
    remotelyPersisted = false
  ) {
    this.id = id || uuidV4();
    this.userId = userId || null;
    this.geoPoint = geoPoint || null;
    this.properties = properties || {};
    this.createdInBackground = createdInBackground;
    this.startedAt = startedAt || new Date();
    this.ntpStartedAt = ntpStartedAt || null;
    this.updatedAt = updatedAt || null;
    this.ntpUpdatedAt = ntpUpdatedAt || null;
    this.closed = closed;
    this.remotelyPersisted = remotelyPersisted;
  }

  public withUpdatedUserId(userId: string): Session {
    const session = Object.create(Session.prototype);

    return Object.assign(session, this, {
      userId,
      updatedAt: new Date(),
    });
  }

  public withUpdatedLocation(geoPoint: GeoPoint): Session {
    const newGeoPoint = Object.create(GeoPoint.prototype);
    const updatedLocation = Object.assign(newGeoPoint, this.geoPoint, geoPoint);
    const session = Object.create(Session.prototype);

    return Object.assign(session, this, {
      geoPoint: updatedLocation,
      updatedAt: new Date(),
    });
  }

  public withAddedProperties(newProperties: object): Session {
    const updatedProperties = Object.assign({}, this.properties, newProperties);
    const session = Object.create(Session.prototype);

    return Object.assign(session, this, {
      properties: updatedProperties,
      updatedAt: new Date(),
    });
  }

  public withRemovedProperty(name: string): Session {
    const updatedProperties: object = Object.assign({}, this.properties);
    const session = Object.create(Session.prototype);

    delete updatedProperties[name];

    return Object.assign(session, this, {
      properties: updatedProperties,
      updatedAt: new Date(),
    });
  }

  public close(): Session {
    const session = Object.create(Session.prototype);

    return Object.assign(session, this, {
      closed: true,
    });
  }

  public persisted(): Session {
    const session = Object.create(Session.prototype);

    return Object.assign(session, this, {
      remotelyPersisted: true,
    });
  }
}

export default Session;
